import { Link } from '@tanstack/react-router'
import { isExactNavMatch } from '@/shared/hooks/use-active-nav-index'
import { useBottomNav } from './bottom-nav.hook'

export type { BottomNavItem } from './bottom-nav.hook'

const ITEM_CLASS =
  'relative flex h-12 flex-col items-center justify-center gap-0.5 rounded-3xl text-xs leading-3 tracking-base text-indigo-900 transition-colors data-[status=active]:text-indigo-base'

const INDICATOR_CLASS =
  'pointer-events-none absolute top-1 left-1 h-12 rounded-3xl bg-indigo-100/64 transition-[transform,opacity] motion-reduce:transition-none'

export function BottomNav() {
  const { items, gridStyle, ariaLabel, hasActive, indicatorStyle } =
    useBottomNav()

  return (
    <nav
      aria-label={ariaLabel}
      style={gridStyle}
      className="relative grid h-14 overflow-clip rounded-4xl border border-indigo-50 bg-white/85 p-1 backdrop-blur-xs"
    >
      <span
        aria-hidden
        className={`${INDICATOR_CLASS} ${hasActive ? 'opacity-100' : 'opacity-0'}`}
        style={indicatorStyle}
        data-testid="bottom-nav-indicator"
      />
      {items.map(({ to, label, icon: Icon, testId }) => (
        <Link
          key={to}
          to={to}
          activeOptions={{ exact: isExactNavMatch(to) }}
          className={ITEM_CLASS}
          data-testid={testId}
        >
          <Icon className="h-4 w-4" />
          {label}
        </Link>
      ))}
    </nav>
  )
}
